/* eslint-disable react/prop-types */
/**
 * @file Contains a method to disallow access to logged in routes while unauthenticated
 * @author Arun Mahadevan
 *
 */
import React from "react";
import { Route } from "react-router-dom";
import { Redirect } from "react-router-dom";
import V2UpgradeInterstitial from "./V2UpgradeInterstitial";
import { isMigratedToV2 } from "../../constants/v2Migration";

/**
 * Checks if the user is authenticated
 * @returns {boolean}
 *
 *
 */
const isAuthenticated = () => {
  const token = sessionStorage.getItem("bearerToken");
  if (token && token !== "") {
    return true;
  }
  return false;
};

/**
 * Disables access to protected routes when unauthenticated. Redirects to /login in that case
 * @param {object} props props to be passed through
 * @returns {component}
 *
 */
const PrivateRoute = props => {
  let routeProps = {
    path: props.path,
    component: props.component,
    exact: props.exact
  };

  if (!isAuthenticated()) {
    return <Redirect to={"/login"} />;
  }

  // Orgs migrated to the new dashboard never see v1 pages — every protected
  // route renders the upgrade notice instead (see constants/v2Migration.js).
  if (isMigratedToV2()) {
    return <V2UpgradeInterstitial />;
  }

  return <Route {...routeProps} />;
};

export default PrivateRoute;
